import CellDateTime from "@/components/functionals/DatetimeFormatter.vue";
import { formatMonto } from "@/utils";
import PerfilPerson from "@/components/functionals/employeePicture.vue";

export const IncomesColumns = [
  {
    prop: "Employee.FullName",
    label: "Empleado",
    "min-width": 100,
    formatter: PerfilPerson
  },
  {
    prop: "income_Type",
    label: "Tipo de Ingreso",
    "min-width": 100
  },
  {
    prop: "income_amount",
    label: "Monto",
    "min-width": 100,
    formatter: (row) => formatMonto(row.income_amount)
  },
  {
    prop: "created_At",
    label: "Fecha de creacion",
    "min-width": 100,
    formatter: CellDateTime
  }
];

export const IncomesActions = [
  {
    label: "Editar Ingreso",
    command: "edit_income",
    icon: "el-icon-edit"
  },
  {
    label: "Borrar Ingreso",
    command: "delete_income",
    icon: "el-icon-delete"
  }
];
/*
export default {
    IncomesColumns,
    IncomesActions
}
*/
